<!--
~ Copyright (c) Siemens, 2023, and licensors.
~ Portions include Open-Source Software. See ReadMe_OSS for details.
~
-->
<ix-layout-grid columns="12">
  @if (loadingInitial) {
    <ix-row>
      <ix-col>
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }

  @if (!loadingInitial) {
    <ix-row>
      <ix-col size="12">
        <ix-content-header
          id="listRemovedPassesHeader"
          headerTitle="{{ 'overview.menu.removed_passports' | translate }}"
        ></ix-content-header>
      </ix-col>
      <ix-col size="12">
        @for (pass of passportList; track pass.passport.id) {
          <ix-row class="w-100 list-item">
            <ix-col size="8">
              <ix-typography
                format="h4"
                id="{{ 'listRemovedPassesItemHeader.' + pass.passport.id }}"
                >
                {{ pass.passport.metadata.name || pass.passport.id }}
              </ix-typography>
            </ix-col>
            <ix-col size="4" class="d-flex align-items-center justify-content-end">
              @if (pass.passport.metadata.masterChildFlag === 'MASTER' && pass.childCount > 0) {
                <ix-pill
                  id="{{pass.passport.id}}IndividualText"
                  class="me-3"
                  variant="custom"
                  background="var(--theme-color-backdrop)"
                  icon="info">
                  <ix-typography
                    textColor="soft"
                    class="pe-2"
                    format="body-sm">
                    {{'battery_pass.removed_list.template_individuals_text' | translate: {passCount: pass.childCount} }}
                  </ix-typography>
                </ix-pill>
                <ix-tooltip
                    id="{{pass.passport.id}}IndividualTooltip"
                    for="[id='{{pass.passport.id}}IndividualText']">
                    <ix-typography format="body-sm">
                      {{'battery_pass.removed_list.template_individuals_tooltip_text' | translate }}
                    </ix-typography>
                  </ix-tooltip>
              }
              <ix-pill
                id="{{ 'listRemovedPassesMasterChildStatus.' + pass.passport.id }}"
                class="me-3"
                icon="info"
            variant="{{
              pass.passport.metadata.masterChildFlag === 'MASTER' ? 'info' : 'neutral'
            }}"
                >{{
                (pass.passport.metadata.masterChildFlag === 'MASTER'
                ? 'battery_pass.list.master'
                : 'battery_pass.list.child'
                ) | translate
                }}
              </ix-pill>
              @if (pass.passport.metadata.masterChildFlag === 'CHILD' && pass.passport.metadata.masterPassportId) {
                <ix-tooltip
                    id="{{pass.passport.id}}MasterPassportTooltip"
                    for="[id='listRemovedPassesMasterChildStatus.{{pass.passport.id}}']">
                    <ix-typography format="body-sm">
                      {{
                        'battery_pass.removed_list.child_master_passport_id'
                          | translate: { masterPassportId: pass.passport.metadata.masterPassportId }
                      }}
                    </ix-typography>
                  </ix-tooltip>
              }
              <ix-pill
                id="{{ 'listRemovedPassesItemStatus.' + pass.passport.id }}"
                variant="custom"
                class="me-3"
                color="white"
            background="{{
              pass.passport.metadata.status.status === 'draft' ? 'orange' : 'green'
            }}"
                >
                {{ 'battery_pass.list.' + pass.passport.metadata.status.status | translate }}
              </ix-pill>
              <ix-button
                class="m-1"
                id="{{ 'listRemovedPassesItemRestoreButton.' + pass.passport.id }}"
                variant="secondary"
                (click)="onRestoreButtonClicked(pass.passport)"
                onkeypress=""
                >
                {{ 'battery_pass.removed_list.restore_button_text' | translate }}
              </ix-button>
            </ix-col>
          </ix-row>
        }
      </ix-col>
    </ix-row>
  }

  @if (
    passportList && passportList.length === 0 && !loadingInitial
    ) {
    <ix-row
      >
      <ix-col>
        <ix-empty-state
        header="{{
          'battery_pass.removed_list.no_passport_available' | translate
        }}"
          icon="trashcan"
          class="no-removed-battery-pass"
        ></ix-empty-state>
      </ix-col>
    </ix-row>
  }
  <ix-row class="w-100">
    <ix-col size="12">
      @if (passportList.length !== 0 && !allLoaded) {
        <div
          class="d-flex flex-row align-items-center justify-content-center my-1"
          >
          <ix-button
            (click)="loadMorePassports()"
            [loading]="loadingMore"
            onkeypress=""
            variant="tertiary"
            >{{ 'battery_pass.list.load_more' | translate }}
          </ix-button>
        </div>
      }
    </ix-col>
  </ix-row>
</ix-layout-grid>
